export default __webpack_public_path__ + "static/media/04__o_preview_2.8c02fa06.jpg";